import 'unfetch/polyfill';

import { setAppLoaded } from "./loading";
import { compileEditPostData } from "../../utils/data.transformations/editPostData";
import { getCookie } from "../../../utils";
import { buildParamsFromState, buildUrlFromParams } from "../../utils/url.write";
import { addErrorMessage, addSuccessMessage, removeAllMessages } from "./messaging";
import { updateRowData } from "./data";

export const SET_IMMUTABLE_EDITING_DATA = 'SET_IMMUTABLE_EDITING_DATA';

export const SHOW_CANCEL_MODAL = 'SHOW_CANCEL_MODAL';
export const SHOW_SAVE_MODAL = 'SHOW_SAVE_MODAL';
export const HIDE_EDITING_MODALS = 'HIDE_EDITING_MODALS';

export const SET_ROW_EDITED = 'SET_ROW_EDITED';

export const CREATE_ADDED_ROW = 'CREATE_ADDED_ROW';
export const UPDATE_ADDED_ROW = 'UPDATE_ADDED_ROW';

export const SET_ROW_DELETED = 'SET_ROW_DELETED';
export const SET_ROW_UNDELETED = 'SET_ROW_UNDELETED';

export const ADD_FIELD_ERROR = 'ADD_FIELD_ERROR';
export const REMOVE_ALL_FIELD_ERRORS = 'REMOVE_ALL_FIELD_ERRORS';


export function setImmutableEditingData(editingEnabled, canAddRows, canDeleteRows, fields, rowKeys,
                                        defaults, options, inputProperties) {
    return {
        type: SET_IMMUTABLE_EDITING_DATA,
        editingEnabled,
        canAddRows,
        canDeleteRows,
        fields,
        rowKeys,
        defaults,
        options,
        inputProperties,
    }
}

export function showCancelModal() {
    return {
        type: SHOW_CANCEL_MODAL
    }
}

export function showSaveModal() {
    return {
        type: SHOW_SAVE_MODAL
    }
}

export function hideEditingModals() {
    return {
        type: HIDE_EDITING_MODALS,
    }
}

export function editRow(rowKey, fieldName, value) {
    return function (dispatch, getState) {

        const { mutableEditing, immutableBaseData, mutableBaseData } = getState();


        return new Promise(function(resolve, reject) {

            // we need to handle editing a preexisting row and a newly added row differently.
            if ( immutableBaseData.rowKeys.includes(rowKey) ) {
                // preexisting row

                // we need to extract this first else it may be the new value, not the pre-editing value
                const currentValue = mutableBaseData.rows[rowKey][fieldName];

                // doesn't really matter what order these happen in, they just both need to happen.
                dispatch( updateRowData(rowKey, fieldName, value) );
                dispatch( setRowEdited(rowKey, fieldName, value, currentValue) );

            } else if ( Object.keys(mutableEditing.addedRows).includes(rowKey) ) {
                // newly added row
                dispatch( updateAddedRow(rowKey, fieldName, value) );
            }
            resolve()
        })
    }
}

function setRowEdited(rowKey, fieldName, value, initialValue) {
    return {
        type: SET_ROW_EDITED,
        rowKey,
        fieldName,
        value,
        initialValue,
    }
}

export function createAddedRow() {
    return function (dispatch, getState) {

        const { immutableBaseData, immutableEditing } = getState();

        const { fields, fieldTypes } = immutableBaseData;
        const { defaults } = immutableEditing;

        dispatch( addAddedRow(fields, fieldTypes, defaults) )
    }
}

function addAddedRow(fields, fieldTypes, defaults) {
    return {
        type: CREATE_ADDED_ROW,
        fields,
        fieldTypes,
        defaults,
    }
}

export function updateAddedRow(rowKey, field, value) {
    return {
        type: UPDATE_ADDED_ROW,
        rowKey,
        field,
        value,
    }
}

export function setRowDeleted(rowKey) {
    return {
        type: SET_ROW_DELETED,
        rowKey,
    }
}

export function setRowUndeleted(rowKey) {
    return {
        type: SET_ROW_UNDELETED,
        rowKey,
    }
}

export function addFieldError(rowKey, fieldErrors) {
    return {
        type: ADD_FIELD_ERROR,
        rowKey,
        fieldErrors,
    }
}


export function removeAllFieldErrors() {
    return {
        type: REMOVE_ALL_FIELD_ERRORS,
    }
}


export function saveEditedStateToServer(endpoint) {

    return (dispatch, getState) => {

        const { immutableBaseData, mutableBaseData, mutableEditing, mutableFiltering, mutableSearching, mutableSorting } = getState();

        const data = compileEditPostData({
            immutableBaseData: immutableBaseData,
            mutableBaseData: mutableBaseData,
            mutableEditing: mutableEditing
        });

        const stateItems = { immutableBaseData, mutableFiltering, mutableSearching, mutableSorting };
        const params = buildParamsFromState(stateItems);

        fetch(endpoint, {
            method: 'post',
            credentials: 'same-origin',
            headers: {
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRFToken': getCookie('csrftoken'),
            },
            body: JSON.stringify(data),
        }).then(response => {

            if ( response.status === 200 ) {
                return response.json()
            } else {
                params['saved'] = [false];  // expects array
                const errorURL = buildUrlFromParams(location.pathname, params);
                window.location = errorURL;
            }

        }).then(json => {
            // clean up existing messages and error state
            dispatch( removeAllFieldErrors() );
            dispatch( removeAllMessages() );

            const { field_errors: fieldErrors, messages } = json;
            const { success: successMessages, error: errorMessages } = messages;

            const fieldErrorRowKeys = Object.keys(fieldErrors);

            if ( fieldErrors.length > 0 || errorMessages.length > 0 || successMessages.length > 0 ) {
                fieldErrorRowKeys.forEach(rowKey => dispatch( addFieldError(rowKey, fieldErrors[rowKey]) ));
                errorMessages.forEach(item => dispatch( addErrorMessage(item.heading, item.content) ));
                // don't expect any success messages at this point, but just in case we will render any we have
                successMessages.forEach(item => dispatch( addSuccessMessage(item.heading, item.content) ));
            } else {
                params['saved'] = [true];  // expects array
                const successURL = buildUrlFromParams(location.pathname, params);
                window.location = successURL;
            }
        }).then(() => dispatch( setAppLoaded() ))
    }

}
